import React from 'react';

function ErrorBanner({ message }) {
  if (!message) return null;

  return (
    <div className="status-banner status-banner-error" role="alert">
      {message}
    </div>
  );
}

export default ErrorBanner;
